module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/menu-top@3x-a4d250b1209f528d00a8f4c5a0318f35.png";